import { Box, Grid, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import LeftTableTiresia from "./analysisComponents/leftTable";
import { useState, useEffect } from "react";
import NetworkMapping from "./analysisComponents/networkMap";
import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import TrendGraph from "./analysisComponents/trendGraph";
import { keyframes } from "@mui/material";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import Stat from "./analysisComponents/stat";
import API from "../../../../api";
import { Skeleton, Stack as LoadingStack } from "@mui/material";
import DetailTable from "./analysisComponents/detailTable";

const colorChange = keyframes`
  0% {
    color: #43B4B9;
  }
  33% {
    color: #596035;
  }
  66% {
    color: #562984;
  }
  100% {
    color: #43B4B9; 
  }
`;

const TiresiaAnalysis = () => {
  const [queryType, setQueryType] = useState({ univocLogsBy: "dettaglio" });
  const [openDialog, setOpenDialog] = useState(false);
  const [level] = useState(0);
  const [startPeriod, setStartPeriod] = useState("");
  const [endPeriod, setEndPeriod] = useState("");
  const [loadingStat, setLoadingStat] = useState(true);
  const [dataStat, setDataStat] = useState({});
  const [detailMap, setDetailMap] = useState()

  useEffect(() => {
    API.getTiresia({ stat: true })
      .then((res) => {
        setDataStat(res.data);
        setLoadingStat(false);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    const formatter = new Intl.DateTimeFormat("it-IT", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
    const today = new Date();
    const startDate = new Date(today);
    startDate.setHours(startDate.getHours() - 24);
    setStartPeriod(formatter.format(startDate));
    setEndPeriod(formatter.format(today));
  }, []);

  return (
    <Box>
      <NetworkMappingDialog
        open={openDialog}
        setOpen={setOpenDialog}
        setOpenDialog={setOpenDialog}
        setQueryType={setQueryType}
        detailMap={detailMap}
        setDetailMap={setDetailMap}
      />
      <Grid container spacing={2}>
        <Grid size={12}>
          {loadingStat ? (
            <Box sx={{ bgcolor: "#1e1e1e", borderRadius: "15px", p: 2 }}>
              <LoadingStack direction="row" spacing={1} sx={{ mb: 2 }}>
                {[...Array(5)].map((_, i) => (
                  <Skeleton key={i} variant="rounded" height={72} sx={{ flex: 1, bgcolor: "rgba(255,255,255,0.07)" }} />
                ))}
              </LoadingStack>
              <Skeleton variant="rounded" height={320} sx={{ bgcolor: "rgba(255,255,255,0.05)" }} />
            </Box>
          ) : (
            <Stat dataStat={dataStat} />
          )}
        </Grid>
        <Grid
          
          alignItems="stretch"
          size={12}
          style={{ position: "relative" }}
        >
              {level < 0 && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    backdropFilter: "blur(5px)",
                    zIndex: 10,
                    pointerEvents: "all",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 24,
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                      color: "orange",
                    }}
                  >
                    Access Restricted{" "}
                    <ReportProblemIcon sx={{ fontSize: 40 }} />
                  </Typography>
                  <Typography
                    sx={{
                      color: "#fff",
                      fontSize: 24,
                      fontWeight: "bold",
                      animation: `${colorChange} 6s infinite`,
                    }}
                  >
                    Wait until Tires-IA reaches 37% of training
                  </Typography>
                </div>
              )}
              <Grid container spacing={2} style={{ height: "100%" }}>
                <Grid container size={detailMap ? 6 : 12} spacing={2}>
                  <Grid size={12}>
                    <Typography sx={{ mb: 1, fontSize: 16, fontWeight: 600 }}>
                      Data from : {startPeriod} to {endPeriod}
                    </Typography>
                  </Grid>
                  <Grid size={12}>
                    <LeftTableTiresia queryType={queryType} setDetailMap={setDetailMap} setQueryType={setQueryType} />
                  </Grid>
                </Grid>
                {detailMap && <Grid size={6}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 30,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography sx={{ fontSize: 18, fontWeight: 600 }}>
                      Tires-IA Anomaly Connection Map
                    </Typography>
                    <IconButton onClick={() => setOpenDialog(true)}>
                      <FullscreenIcon />
                    </IconButton>
                  </div>
                  <NetworkMapping setQueryType={setQueryType} detailMap={detailMap} />
                  <DetailTable detailMap={detailMap} />
                </Grid>}
                <Grid size={12}>
                  <TrendGraph />
                </Grid>
              </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TiresiaAnalysis;

const NetworkMappingDialog = ({open, setOpen, setQueryType, setOpenDialog, detailMap}) => {
  return(
    <Dialog
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          "& .MuiDialog-paper": {
            width: "100%",
            height: "100%",
            maxWidth: "none",
            backgroundColor: "4e4e4e",
            backgroundImage: "none",
          },
        }}
      >
        <IconButton
          onClick={() => setOpen(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent style={{ paddingTop: 40 }}>
          <NetworkMapping
            dialog={open}
            setQueryType={setQueryType}
            setOpenDialog={setOpenDialog}
            detailMap={detailMap}
          />
        </DialogContent>
      </Dialog>
  )
};